import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=25c79754&scoped=true"
import script from "./DashboardView.vue?vue&type=script&lang=js"
export * from "./DashboardView.vue?vue&type=script&lang=js"
import style0 from "./DashboardView.vue?vue&type=style&index=0&id=25c79754&prod&lang=css"
import style1 from "./DashboardView.vue?vue&type=style&index=1&id=25c79754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c79754",
  null
  
)

export default component.exports